import React, {useEffect, useState} from "react"
import Image from "../global/Image"
import Lightbox from 'react-image-lightbox';
import {useDispatch, useSelector} from "react-redux"
import {addHint, hover, select} from "../../store/actions/game"
import {useParams} from "react-router"
import {isMobile} from "../../helpers/device"

export default ({ artWork, selected }) => {

    const dispatch = useDispatch();
    const state = useSelector(state => state.game);
    let { gameSlug } = useParams();

    const { hints, artWorksLoading, hoverArtWorkId } = state;

    const showHint = hints.includes(artWork.id)
    const showLoading = artWorksLoading.includes(artWork.id)

    const [showLightBox, setShowLightBox] = useState(false);
    const [lastEvent, setLastEvent] = useState(null);

    const onSelect = (e) => {
        if(selected || showLoading) return;
        e.stopPropagation();

        if(isMobile()) {
            if(hoverArtWorkId === artWork.id){
                dispatch(select(gameSlug, artWork.id));
            } else {
                dispatch(hover(artWork));
            }
        } else {
            dispatch(select(gameSlug, artWork.id));
        }
    }
    const showImage = (e) => {
        e.stopPropagation();
        setShowLightBox(true);
    }
    const hint = (e) => {
        if(selected || showLoading) return;
        e.stopPropagation();
        dispatch(addHint(gameSlug, artWork.id));
    }

    useEffect(() => {
        return () => {
            if(showHint) {
                clearTimeout(showHint);
            }
        }
    }, [showHint]);

    const onTouch = (e) => {
        e.stopPropagation();
        if(isMobile()) return;

        if(e.type === 'touchend' && lastEvent === 'touchstart') {
            if(hoverArtWorkId !== artWork.id) {
                dispatch(hover(artWork));
            } else {
                dispatch(select(gameSlug, artWork.id));
            }
        }

        setLastEvent(e.type)
        if(e.type === 'touchend' && hoverArtWorkId !== artWork.id){
            dispatch(hover(artWork));
        }

    }

    const onHover = (e) => {
        if(!isMobile()) {
            e.stopPropagation();
            if(hoverArtWorkId !== artWork.id) {
                dispatch(hover(artWork))
            }
        }
    }

    return (
        <>
            {showLightBox &&
            <Lightbox
                imageTitle={`${artWork.title} (${artWork.date})`}
                enableZoom={false}
                mainSrc={`${process.env.REACT_APP_CDN}/${artWork.image}`}
                onCloseRequest={() => setShowLightBox(false)}
            />
            }
            <div
                onTouchEnd={onTouch}
                onTouchMove={onTouch}
                onTouchStart={onTouch}
                onMouseOver={onHover}
                onClick={(e) => onSelect(e)}
                className={`game-option col-xl-3 col-sm-4 col-6 ${selected && selected.type.toLowerCase()} ${(hoverArtWorkId === artWork.id) ? 'hover' : ''}`}
            >
                <div className="artwork-option">
                    <Image title={artWork.title} src={artWork.image} alt={artWork.title}/>
                </div>
                <h6 className="artwork-title" title={artWork.title}>{artWork.title}</h6>
                { !showLoading && <div className="artwork-details">{artWork.date}</div> }
                {
                    showHint &&
                    <div className="artwork-hint-result">
                        <i className="fa fa-lightbulb-o"/>
                        <strong className="">{' '}{artWork.artist.nick}</strong>
                    </div>
                }
                {
                    !showLoading &&
                    <div className="artwork-action">
                        <span onClick={(e) => onSelect(e)} className="action check"><i className="fa fa-check"/></span>
                        <span onClick={(e) => showImage(e)} className="action"><i className="fa fa-search-plus"/></span>
                        <span onClick={(e) => hint(e)} className="action"><i className="fa fa-lightbulb-o"/></span>
                    </div>
                }

                <span className="icon-failed"><i className="fa fa-times-circle fa-4"/></span>
                <span className="icon-selected"><i className="fa fa-check-circle fa-4"/></span>
                { showLoading && <span className="icon-loading"><i className="fa fa-spinner fa-spin fa-4"/></span> }
            </div>
        </>
    );
}
